import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Checkbox } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { Delete } from "@mui/icons-material";

const useColumns = (
  setViewProduct,
  setSelectedPackage,
  handleModalOpen,
  handleModalDeleteOpen
) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState({});
  const [activeRowId, setActiveRowId] = useState(null);

  const handleMenuOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
    setActiveRowId(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveRowId(null);
  };

  const handleCheckboxChange = (id) => {
    setSelected((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const columns = [
    // {
    //   Header: "",
    //   accessor: "checkbox",
    //   width: "50px",
    //   disableSortBy: true,
    //   Cell: ({ row }) => (
    //     <Checkbox
    //       checked={selected[row.values.id] || false}
    //       onChange={() => handleCheckboxChange(row.values.id)}
    //     />
    //   ),
    // },
    // {
    //   Header: "",
    //   accessor: "expand",
    //   width: "100px",
    //   disableSortBy: true,
    //   Cell: ({ row }) =>
    //     row.values.actions ? (
    //       <IconButton onClick={() => row.toggleRowExpanded()}>
    //         <ExpandMoreIcon />
    //       </IconButton>
    //     ) : null,
    // },

    { Header: "ชื่อแพ็กเกจ", accessor: "name_package", showInFilter: false },
    { Header: "จำนวนเครดิต", accessor: "credit", showInFilter: false },
    { Header: "จำนวนวัน", accessor: "total_day", showInFilter: false },
    { Header: "ราคา", accessor: "price", showInFilter: false },
    { Header: "วันที่เริ่มต้น", accessor: "start_date", showInFilter: false },
    { Header: "วันที่สิ้นสุด", accessor: "end_date", showInFilter: false },
    { Header: "สถานะ", accessor: "status", showInFilter: false },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      Cell: ({ row }) => {
        console.log("row", row);
        return (
          <div>
            <IconButton
              onClick={(event) =>
                handleMenuOpen(event, row.marketplace_package_id)
              }
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={
                Boolean(anchorEl) && activeRowId === row.marketplace_package_id
              }
              onClose={handleMenuClose}
            >
              <MenuItem
                onClick={() => {
                  setSelectedPackage(row);
                  handleModalOpen();
                  handleMenuClose();
                }}
              >
                <BorderColorIcon
                  style={{ marginRight: "8px", color: "#737373" }}
                />
                <span style={{ marginLeft: "8px", color: "#737373" }}>
                  แก้ไข
                </span>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  console.log(row);

                  setSelectedPackage(row);
                  handleModalDeleteOpen(row);
                  handleMenuClose();
                }}
              >
                <Delete style={{ marginRight: "8px", color: "#737373" }} />
                <span style={{ marginLeft: "8px", color: "#737373" }}>ลบ</span>
              </MenuItem>
              {/* <MenuItem
                onClick={() => {
                  // console.log("Delete product with ID:", row.original.id);
                  handleMenuClose();
                }}
              >
                <LocalPrintshopIcon
                  style={{ marginRight: "8px", color: "#737373" }}
                />
                <span style={{ marginLeft: "8px", color: "#737373" }}>
                  พิมพ์ใบรับซื้อสินค้า
                </span>
              </MenuItem> */}
            </Menu>
          </div>
        );
      },
    },
  ];

  return columns;
};

export default useColumns;
